import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DELIVERY, PICKUP, ReceiptType } from '@checkout/const';
import { ReceiptService } from '@checkout/feature';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { Observable } from 'rxjs';

@Component({
  selector: 'sd-receipt-type-tabs',
  templateUrl: './receipt-type-tabs.component.html',
  styleUrls: ['./receipt-type-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorReceiptTypeTabsComponent implements OnInit {
  receiptTypes$: Observable<ReceiptType[]>;
  activeModeId$: Observable<string>;

  variantIcon: { [code: string]: CUSTOM_ICON_TYPE } = {
    [DELIVERY]: CUSTOM_ICON_TYPE.LORRY,
    [PICKUP]: CUSTOM_ICON_TYPE.SHOP,
  };

  constructor(private receiptService: ReceiptService) {}

  ngOnInit(): void {
    this.receiptTypes$ = this.receiptService.receiptTypes$;
    this.activeModeId$ = this.receiptService.activeReceiptTypeId$;
  }

  setActive(code: string): void {
    this.receiptService.setActiveReceiptType(code);
  }
}
